import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { SharedService } from './shared/services/shared.service';
import { BnNgIdleService } from 'bn-ng-idle';
import { AuthService } from './shared/services/auth.service';
import {MatPaginatorIntl} from "@angular/material/paginator";

const getRangeLabel: (page: number, pageSize: number, length: number) => string = (
  page: number,
  pageSize: number,
  length: number
): string => {
  return new MatPaginatorIntl().getRangeLabel(page, pageSize, length).replace(/[a-z]+/i, 'de');
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'pnloti-ui';

  constructor(
    private snackbar: MatSnackBar,
    private sharedService: SharedService,
    private router: Router,
    private authService:AuthService,
    private bnIdle: BnNgIdleService,
    private paginator: MatPaginatorIntl
  ) {
    this.paginator.itemsPerPageLabel = "Registros por página";
    this.paginator.nextPageLabel = "Página siguiente";
    this.paginator.previousPageLabel = "Página anterior";
    this.paginator.firstPageLabel = "Primera página";
    this.paginator.lastPageLabel = "ültima página";
    this.paginator.getRangeLabel = getRangeLabel;

    setTimeout(() => {
      if (!this.sharedService.userSession) {
        this.router.navigate(['/home'], { skipLocationChange: true });
      }
    }, 2000);

    this.bnIdle.startWatching(60*30).subscribe((res) => {
      if (res) {
        this.authService.logOut();
      }
    });
  }

  ngOnInit(): void {
    this.authService.validateSession();
  }

}
